import { Form } from '@vivaldis/antd-ui'
import { Step, useStep } from '../../provider/StepProvider'
import { CountryType } from '../../types/CountryType'
import { Employee } from '../../types/Employee'
import { ActionBar } from './components/ActionBar'
import { FormContent } from './components/FormContent'
import { FormProvider } from './provider/FormProvider'

interface Props {
  employee: Employee
  onGoBack: () => void
  countries: CountryType[]
}

export const OcrSucceededStep = ({ employee, onGoBack, countries }: Props) => {
  const { step } = useStep()

  if (step !== Step.OcrSucceededStep) {
    return null
  }

  return (
    <FormProvider employee={employee}>
      <Form>
        <FormContent countries={countries} />
        <ActionBar onGoBack={onGoBack} />
      </Form>
    </FormProvider>
  )
}
